import React from 'react';
import { Hero } from './components/sections/Hero';
import { PainPoints } from './components/sections/PainPoints';
import { Tomos } from './components/sections/Tomos';
import { Bonuses } from './components/sections/Bonuses';
import { Pricing } from './components/sections/Pricing';
import { EliteProtocol } from './components/sections/EliteProtocol';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { PurchaseNotifier } from './components/PurchaseNotifier';
import { StickyCTA } from './components/StickyCTA';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="w-full bg-ink text-ice" data-id="element-0" data-mp="2wi5m1f302hnq">
      <MetaPixel data-id="element-1" data-mp="28te2td7e19n3" />
      <Hero data-id="element-2" data-mp="28suw6sn6u7od" />
      <main data-id="element-3" data-mp="28sl0cofgp6ar">
        <PainPoints data-id="element-4" data-mp="28s2zfehuu3wi" />
        <Tomos data-id="element-5" data-mp="23vktwcepa1j4" />
        <Bonuses data-id="element-6" data-mp="23w4drynwuzzs" />
        <Pricing data-id="element-7" data-mp="23ujlygszdv5m" />
        <EliteProtocol data-id="element-8" data-mp="23v2sl1d6kx4c" />
        <Guarantee data-id="element-9" data-mp="3ijxpqrsp22kf" />
        <Faq data-id="element-10" data-mp="3ikh829m9asyz" />
        <FinalCTA data-id="element-11" data-mp="3ikqwhsrnks2k" />
      </main>
      <Footer data-id="element-12" data-mp="3ijpcgysnsv8p" />
      <PurchaseNotifier data-id="element-13" data-mp="3ihuyy5jpw5en" />
      <StickyCTA data-id="element-14" data-mp="3mlax56bfqdtg" />
    </div>;
}